import { render, staticRenderFns } from "./VaIconVuestic.demo.vue?vue&type=template&id=32cb9794&"
import script from "./VaIconVuestic.demo.vue?vue&type=script&lang=js&"
export * from "./VaIconVuestic.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports